import { Match, Schema } from 'effect';

export const GtmListIdType = {
  BRAND_PRODUCTS: 'brand-products',
  CATEGORY_PRODUCTS: 'category-products',
  SEARCH_PRODUCTS: 'search-products',
  HOMEPAGE_PRODUCTS: 'homepage-products',
  CATEGORY_BESTSELLERS: 'category-bestsellers',
  VARIANTS_OF_PRODUCT: 'variants-of-product',
  PRODUCT_RECOMMENDATIONS: 'product-recommendations',
} as const;

export type GtmListIdTypeT = (typeof GtmListIdType)[keyof typeof GtmListIdType];

export const GtmListIdSchema = Schema.Literals(Object.values(GtmListIdType));

export const GtmListNameType = {
  BRAND_PRODUCTS: 'Brand products',
  CATEGORY_PRODUCTS: 'Category products',
  SEARCH_PRODUCTS: 'Search products',
  HOMEPAGE_PRODUCTS: 'Homepage products',
  CATEGORY_BESTSELLERS: 'Category-bestsellers',
  VARIANTS_OF_PRODUCT: 'Variants of product',
  PRODUCT_RECOMMENDATIONS: 'Product recommendations',
} as const;

export type GtmListNameTypeT = (typeof GtmListNameType)[keyof typeof GtmListNameType];

export const GtmListNameSchema = Schema.Literals(Object.values(GtmListNameType));

export const getListNameTypeFromId = (id: GtmListIdTypeT) =>
  Match.value(id).pipe(
    Match.withReturnType<GtmListNameTypeT>(),
    Match.when(GtmListIdType.BRAND_PRODUCTS, () => GtmListNameType.BRAND_PRODUCTS),
    Match.when(GtmListIdType.CATEGORY_PRODUCTS, () => GtmListNameType.CATEGORY_PRODUCTS),
    Match.when(GtmListIdType.SEARCH_PRODUCTS, () => GtmListNameType.SEARCH_PRODUCTS),
    Match.when(GtmListIdType.HOMEPAGE_PRODUCTS, () => GtmListNameType.HOMEPAGE_PRODUCTS),
    Match.when(GtmListIdType.CATEGORY_BESTSELLERS, () => GtmListNameType.CATEGORY_BESTSELLERS),
    Match.when(GtmListIdType.VARIANTS_OF_PRODUCT, () => GtmListNameType.VARIANTS_OF_PRODUCT),
    Match.when(
      GtmListIdType.PRODUCT_RECOMMENDATIONS,
      () => GtmListNameType.PRODUCT_RECOMMENDATIONS
    ),
    Match.exhaustive
  );
